import { Accordion, AccordionDetails, AccordionSummary, Divider } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { Bold, Title } from '../styles';

export default function ProductHeader({ showDeliveryAddress, paymentData, shippingAddress, totalOrder, status }) {
  return (
    <>
    <Title style={{ margin: "24px 0 20px" }}>
      {status || '-'}
    </Title>
    <Accordion sx={{ boxShadow: 0 }} className="accordion">
      <AccordionSummary
        className="accordion-summary p-0"
        expandIcon={<HiOutlineChevronDown />}
        aria-controls="panel1a-content"
      >
        <Title style={{ fontSize: "15px", fontWeight: "500" }}>
          Forma de Pagamento
        </Title>
      </AccordionSummary>
      <AccordionDetails>
        <Title style={{ fontSize: "15px", fontWeight: "500", marginBottom: "16px", opacity: "0.6" }}>
          {paymentData?.type || '-'}
        </Title>
        <div style={{ maxWidth: "100%", wordBreak: "break-word" }}>
          <Bold style={{ fontSize: "13px", fontWeight: "300", marginBottom: "12px", marginTop: "0px" }}>
            {paymentData?.description || '-'}
            {paymentData?.cardInfo ? (
              <>
                <br /> 
                {paymentData.cardInfo}
              </>
            ) : null}
          </Bold>
        </div>
      </AccordionDetails>
    </Accordion>
    {showDeliveryAddress && shippingAddress && (
      <Accordion sx={{ boxShadow: 0 }} className="accordion">
        <AccordionSummary
          className="accordion-summary p-0"
          expandIcon={<HiOutlineChevronDown />}
          aria-controls="panel2a-content"
        >
          <Title style={{ fontSize: "15px", fontWeight: "500" }}>
            Endereço de entrega
          </Title>
        </AccordionSummary>
        <AccordionDetails>
          <Title style={{ fontSize: "15px", fontWeight: "500", marginBottom: "16px", opacity: "0.6" }}>
            {shippingAddress.label || '-'}
          </Title>
          <div style={{ maxWidth: "100%", wordBreak: "break-word" }}>
            <Bold style={{ fontSize: "12px", marginBottom: "12px", marginTop: "0px", fontWeight: "300" }}>
              {shippingAddress.street || '-'}
              {shippingAddress.neighborhood ? (
                <>
                  <br />
                  {shippingAddress.neighborhood}
                  {shippingAddress.complement ? `, ${shippingAddress.complement}` : ''}
                </>
              ) : null}
              {(shippingAddress.city || shippingAddress.state || shippingAddress.zipCode) ? (
                <>
                  <br />
                  {shippingAddress.city ? `${shippingAddress.city}` : '-'}
                  {shippingAddress.state ? `, ${shippingAddress.state}` : ''}
                  {shippingAddress.zipCode ? ` - ${shippingAddress.zipCode}` : ''}
                </>
              ) : null}
            </Bold>
          </div>
        </AccordionDetails>
      </Accordion>
    )}
    <Divider />
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "16px 0 10px" }}>
      <Title>
        Total do pedido
      </Title>
      <Title>
        {totalOrder || '-'}
      </Title>
    </div>
    <Divider />  
    </>                
  );
}

ProductHeader.propTypes = {
  showDeliveryAddress: PropTypes.bool,
  paymentData: PropTypes.shape({
    type: PropTypes.string,
    description: PropTypes.string,
    cardInfo: PropTypes.string,
  }),
  shippingAddress: PropTypes.shape({
    label: PropTypes.string,
    street: PropTypes.string,
    neighborhood: PropTypes.string,
    complement: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
  }),
  totalOrder: PropTypes.string,
  status: PropTypes.string,
};

ProductHeader.defaultProps = {
  showDeliveryAddress: false,
  paymentData: null,
  shippingAddress: null,
  totalOrder: '0,00 pts',
  status: 'Aprovado',
};